import { render, staticRenderFns } from "./HomeAppLanding.vue?vue&type=template&id=48fb1734&"
import script from "./HomeAppLanding.vue?vue&type=script&lang=js&"
export * from "./HomeAppLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports